<ng-container *ngIf="hasPermission$ | async; else noPermission">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #noPermission>
  <ui-forbidden></ui-forbidden>
</ng-template>
